import React from "react";
import { Link } from "react-router-dom";
import { useAccount, useDisconnect } from "wagmi";
import { Coins, Flame, LogOut, User, LayoutDashboard, FileText } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { useApp } from "@/App";

const EXTRA = [
  { to: "/profile", label: "Profile & Claim", icon: User, tid: "more-link-profile" },
  { to: "/creator", label: "Creator Dashboard", icon: LayoutDashboard, tid: "more-link-creator" },
  { to: "/whitepaper", label: "White Paper", icon: FileText, tid: "more-link-whitepaper" },
];

export function MoreSheet({ open, onOpenChange, links }) {
  const { isConnected } = useAccount();
  const { disconnect } = useDisconnect();
  const { user } = useApp();
  const close = () => onOpenChange(false);
  const all = [...links.map((l) => ({ ...l, tid: `more-${l.tid}` })), ...(isConnected ? EXTRA : EXTRA.slice(2))];
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" className="bg-[#181A26] border-[#2A2E45] text-slate-100 rounded-t-3xl pb-[calc(1.5rem+env(safe-area-inset-bottom))] max-h-[85vh] overflow-y-auto" data-testid="more-sheet">
        <SheetHeader className="text-left">
          <SheetTitle className="font-display text-2xl text-slate-100">More</SheetTitle>
          <SheetDescription className="sr-only">All FLAME pages</SheetDescription>
        </SheetHeader>
        {user && (
          <div className="mt-3 flex gap-2" data-testid="more-sheet-balances">
            <div className="chip"><Coins size={14} className="text-cyan-400" /> {user.credits} credits</div>
            <div className="chip"><Flame size={14} className="text-orange-500" /> {user.flame} FLAME</div>
          </div>
        )}
        <div className="mt-4 grid grid-cols-3 gap-2">
          {all.map((l) => (
            <Link key={l.to} to={l.to} onClick={close} data-testid={l.tid}
              className="rounded-2xl bg-[#12131C] border border-[#2A2E45] active:border-orange-500/50 p-3 flex flex-col items-center gap-1.5 text-center text-xs font-semibold min-h-[76px] justify-center">
              <l.icon size={20} className="text-orange-400" /> {l.label}
            </Link>
          ))}
        </div>
        {isConnected && (
          <button onClick={() => { disconnect(); close(); }} className="btn-tactile btn-ghost w-full mt-4 flex items-center justify-center gap-2 text-sm" data-testid="more-disconnect">
            <LogOut size={16} /> Disconnect wallet
          </button>
        )}
      </SheetContent>
    </Sheet>
  );
}
